// extracted by css-extract-rspack-plugin
export default {"cardGrid":"WhitepaperIndex-module__cardGrid__AV3lw","layoutGrid":"WhitepaperIndex-module__layoutGrid__lPfN3","filtersColumn":"WhitepaperIndex-module__filtersColumn__wgeYN"};